import { render } from "./tableIndexes.vue?vue&type=template&id=c0b13cbe&ts=true"
import script from "./tableIndexes.vue?vue&type=script&lang=ts"
export * from "./tableIndexes.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__